import { HomeExploreDataInterface } from '../utils/types';
import index02 from '../assets/beach.jpg';
import index01 from '../assets/double.jpg';

export const HomeExploreData: Array<HomeExploreDataInterface> = [
  {
    id: 1,
    img: index01,
    title: 'Luxury Redefined',
    text: 'Our rooms are defined to transport you into an environment made for leisure. Take you mind of the day-to-day of home life and find a private paradise for yourself.',
  },
  {
    id: 2,
    img: index02,
    title: 'Leave your worries in the sand',
    text: 'We love life at the beach. Being close to the ocean with access to endless sandy beach ensures a relaxed state of mind. It seems like time stands still watching the ocean.',
  },
];
